import React, { useRef, InputHTMLAttributes } from "react";

// packages
import classnames from "classnames";

// material ui componetns
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import TextField from "@mui/material/TextField";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";

// styles
import styles from "./styles.module.scss";
import { ar } from "date-fns/locale";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "value"> {
  value?: Date | null;
  handleChange: (value: any) => void;
  maxDate?: Date;
  minDate?: Date;
  label?: string;
  style?: React.CSSProperties;
}

const DateTimePicker: React.FC<Props> = ({
  handleChange,
  maxDate,
  minDate,
  style,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={classnames(styles.container)} style={style}>
      <LocalizationProvider
        dir="rtl"
        adapterLocale={ar}
        dateAdapter={AdapterDateFns}>
        {!props.value && (
          <label className={styles.placeholder}>{props.placeholder}</label>
        )}
        <DesktopDateTimePicker
          className={styles.dateTimePicker}
          ref={inputRef}
          label={<p>{props?.label || ""}</p>}
          toolbarPlaceholder={""}
          inputFormat="yyyy/MM/dd hh:mm a"
          ampm={true}
          value={props.value}
          onChange={(date) => {
            handleChange(date);
          }}
          renderInput={(params) => <TextField {...params} />}
          maxDate={maxDate ? maxDate : null}
          minDate={minDate ? minDate : null}
        />
      </LocalizationProvider>
    </div>
  );
};

export default React.memo(DateTimePicker);
